'use client';
import { IRepository, ICommit } from '@/types';
import Commit from '@/components/Repository/Commit';
import Cardlist from '@/ui/CardList';

import * as Styled from './styled';

const CommitList: React.FC<{
  repository: IRepository;
  commits: ICommit[];
  resourcePath?: string;
  resourceType?: 'dir' | 'file';
}> = ({ repository, commits, resourcePath, resourceType }) => {
  return (
    <Styled.CommitList>
      <Cardlist compressed>
        {commits?.map((commit: ICommit) => (
          <Commit
            repository={repository}
            key={commit.id}
            commit={commit}
            resourcePath={resourcePath}
            resourceType={resourceType}
          />
        ))}
      </Cardlist>
    </Styled.CommitList>
  );
};

export default CommitList;
